import styled from 'styled-components';

export const $LoaderContainer = styled.div<{ $size: string }>`
  width: ${({ $size }) => $size};
  position: fixed;
  bottom: 2rem;
  left: 50%;
`;
